import React, { useMemo } from 'react';
import { Auth } from 'components/Auth/Auth';
import { isAdminRole } from '../../../utils/userActionUtils';
import { MAX_FILE_SIZE_MB, MAX_FILES_ADMIN, MAX_FILES_BASIC } from '../useUploadFilesAudio';
import classNames from './InstructionDropZone.module.scss';

export function InstructionDropZoneAudio() {
  const user = useMemo(() => new Auth().getUser(), []);
  const maxFiles = isAdminRole(user) ? MAX_FILES_ADMIN : MAX_FILES_BASIC;

  return (
    <div className={classNames.container}>
      <h4 className={classNames.textHeader}>Quick Guidelines for Uploading Audio Files:</h4>
      <div className={classNames.text}>
        <h5 id="requirements">Requirements</h5>
        <ul>
          <li>
            {'File Names: '}
            <code>[audio name].mp3</code>
            {' or '}
            <code>[audio name].wav</code>
          </li>
          <li>
            {'Auto-detect type: Use '}
            <code>_music</code>
            {' or '}
            <code>_sfx</code>
            {' in filename. Example: '}
            <code>battle_music.mp3</code>
            {', '}
            <code>explosion_sfx.wav</code>
          </li>
          <li>
            Maximum file size:
            {' '}
            {MAX_FILE_SIZE_MB}
            MB per file
          </li>
          <li>
            {'Supported Formats: '}
            <code>*.mp3</code>
            {' or '}
            <code>*.wav</code>
          </li>
          <li>
            You can upload a maximum of
            {' '}
            {maxFiles}
            {' '}
            files at a time
          </li>
        </ul>
        <h5 id="notes">Notes</h5>
        <ul>
          <li>Audio files will be converted to standard format before uploading</li>
          <li>If type is not auto-detected from filename, you must select it manually</li>
        </ul>
      </div>
      <h3 className={classNames.dropHere}>Drop the files here OR click to choose files...</h3>
    </div>
  );
}
